import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DemoSettingsActions } from './demo-settings.actions';
import { DemoSettingsStore } from './demo-settings.store';
import { demoSettingsConfigStorageKey } from './demo-settings.state';

@Injectable({ providedIn: 'root' })
export class DemoSettingsEffects {
  constructor(private actions$: Actions, private demoSettingsStore: DemoSettingsStore) {}

  saveConfig$: Observable<void> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(
          DemoSettingsActions.addFeatures,
          DemoSettingsActions.removeFeatures,
          DemoSettingsActions.updatePlan
        ),
        concatLatestFrom(() => this.demoSettingsStore.selectSubscriptionWithPaidFeatures$),
        map(([_action, selectSubscriptionWithPaidFeatures]) => {
          sessionStorage.setItem(
            demoSettingsConfigStorageKey,
            JSON.stringify(selectSubscriptionWithPaidFeatures)
          );
        })
      );
    },
    { dispatch: false }
  );

  loadConfigFromStorage$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(DemoSettingsActions.loadDemoConfig.attempt),
      map((_action) => {
        const selectSubscriptionWithPaidFeatures = sessionStorage.getItem(
          demoSettingsConfigStorageKey
        );
        if (selectSubscriptionWithPaidFeatures) {
          return DemoSettingsActions.loadDemoConfig.success({
            selectSubscriptionWithPaidFeatures: JSON.parse(selectSubscriptionWithPaidFeatures),
          });
        } else {
          return DemoSettingsActions.loadDemoConfig.empty();
        }
      }),
      catchError((error) => of(DemoSettingsActions.loadDemoConfig.error({ error })))
    );
  });

  removeConfig$: Observable<void> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(DemoSettingsActions.removeDemoConfig),
        map((_action) => {
          sessionStorage.removeItem(demoSettingsConfigStorageKey);
        })
      );
    },
    { dispatch: false }
  );
}
